import dayjs from "dayjs"

const Dayjs = {
  get date() {
    return dayjs().format("YYYY-MM-DD")
  },
  get timeStamp() {
    return dayjs().toISOString()
  },
}
export default Dayjs
